import {
  ADD_LOADED_PAGE,
  FETCH_APP_CONFIG,
  SET_DATA_LOADER,
} from "../actions/types";

const initialState = {
  appConfig: null,
  loader: "",
  loadedPages: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_APP_CONFIG:
      return {
        ...state,
        appConfig: action.payload,
      };

    case SET_DATA_LOADER:
      return {
        ...state,
        loader: action.payload,
      };

    case ADD_LOADED_PAGE:
      return {
        ...state,
        loadedPages: [...state.loadedPages, action.payload],
      };

    default:
      return state;
  }
}
